import React from 'react'
import { Image } from 'antd'
import defaultImg from 'app/assets/images/default.png'
import styles from './index.module.less'

type ProductInfoCardProps = {
  data?: SwaggerDTO.我的订单分页查询订单商品返回对象 & {
    barCode: string
  }
}

export default function ProductInfoCard({ data }: ProductInfoCardProps) {
  return (
    <div className={styles.productInfo}>
      <Image
        className={styles.infoImg}
        src={data?.skuImageUrl || defaultImg}
        alt=""
      />
      <div className={styles.info}>
        <p className={styles.title}>{data?.skuName}</p>
        <p className={styles.text}>
          {data?.barCode ? data.barCode + '，' : ''}
          {data?.productTypeFullName}
        </p>
      </div>
    </div>
  )
}
